/** Zwei aufeinanderfolgende Bestätigungen bei offener Rechnung oder fehlender Rechnung. */
export function confirmRiskyCheckOut(
  booking: {
    open_invoice_amount: string;
    currency: string;
    invoice_count: number;
  },
  formatMoney: (amount: string, currency: string) => string,
): boolean {
  const open = Number(booking.open_invoice_amount);
  const noInvoice = booking.invoice_count === 0;

  if (open <= 0 && !noInvoice) return true;

  let firstMessage: string;
  let secondMessage: string;

  if (open > 0 && noInvoice) {
    firstMessage =
      "Für diese Buchung wurde noch keine Rechnung erstellt und es stehen offene Beträge aus. Trotzdem auschecken?";
    secondMessage =
      "Bitte nochmals bestätigen: Check-out ohne Rechnung und mit offenem Betrag durchführen?";
  } else if (open > 0) {
    firstMessage = `Für diese Buchung stehen noch ${formatMoney(
      booking.open_invoice_amount,
      booking.currency,
    )} offen. Trotzdem auschecken?`;
    secondMessage = `Bitte nochmals bestätigen: Check-out trotz offenem Betrag von ${formatMoney(
      booking.open_invoice_amount,
      booking.currency,
    )}?`;
  } else {
    firstMessage =
      "Für diese Buchung wurde noch keine Rechnung erstellt. Trotzdem auschecken?";
    secondMessage =
      "Bitte nochmals bestätigen: Check-out ohne erstellte Rechnung durchführen?";
  }

  if (!window.confirm(firstMessage)) return false;
  if (!window.confirm(secondMessage)) return false;
  return true;
}
